export const componentType = 'Column';
export const ARIA_LABEL_NAMESPACE = 'ariaLabels';
export const ARIA_LABEL_KEY = 'interactions_AriaLabel_contentOnHover_message';
export const ARIA_LABEL_DEFAULT =
  'Interactive element, focus to trigger content change';
